<template>
	<div>
		<import	import-url="/api/parts/import" template-url="/parts/import-template" file-name="parts_file"></import>
	</div>
</template>

<script>
	import Import from "@components/partials/Import";

	export default {
		components: {
			Import
		},
	};
</script>
